<template>
  <div class="zx-box">
	<div class="zx-box-title">
		<img src="../../assets/image/zhibojian_zaixianguanzhong@2x.png" alt=""/>
		<span>{{$t('all.zaixianguanzhong')}}：{{total}}</span>
	</div>  
	<div class="zx-box-list" ref="listContainer" @scroll="handleScroll">
		<div class="zx-box-list-item" v-for="(item,index) in list" :key="index" @click="handleShowUser(item.userId)">
			<img :src="item.headPortrait" alt="" />
			<span>{{item.nickName}}</span>
		</div>
	</div>
  </div>
</template>

<script>
import { getChatRoomOnlineUserList,getChatRoomOnlineUserCount } from "@/api/zhibo";
export default {
  name:'zaixianyonghu',
  data() {
    return {
	  queryParams: {
	    page: 1,
	    size: 100,
		liveId:this.$route.query.liveId
	  },
	  hasMore: true,
	  list: [],
	  total:0
    };
  },
  mounted() {
	this.getChatRoomOnlineUserList()
	this.getChatRoomOnlineUserCount()
  },
  methods: {
	//直播间在线总用户
	async getChatRoomOnlineUserCount(){
		const res = await getChatRoomOnlineUserCount(this.queryParams)
		this.total = res.data
	},
	//直播间在线用户列表
	async getChatRoomOnlineUserList(){
		const response = await getChatRoomOnlineUserList(this.queryParams)
		 this.list = response.rows 
	},
	// 滚动事件处理函数
	handleScroll() {
	//   if (!this.hasMore) {
	// 	return;
	//   }
	
	//   const container = this.$refs.listContainer;
	//   const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50; // 50px的缓冲距离
	
	//   if (isAtBottom) {
	// 	console.log("滚动到底部，触发加载更多");
	// 	this.queryParams.page++;
	// 	this.getChatRoomOnlineUserList();
	//   }
	},
	//显示用户信息
	handleShowUser(id){
		this.$emit('show_user',id)
	}

  }
};
</script>
<style scoped lang="scss">
	@import "./zaixianguanzhong.css";
</style>


// WEBPACK FOOTER //
// zaixianguanzhong.vue?18bbce85